<template>
  <tr>
    <td>{{tableRowNumber(currentPage, perPage, index)}}</td>
    <td>{{auctionHouse.name}}</td>
    <td>
      <a
        :href="Routes.employees_auctions_catalog_artworks_path({ id: auctionsCatalog.slug })"
        class="link--orange"
      >
        {{auctionsCatalog.name}}
      </a>
    </td>
    <td>{{address.city}}</td>
    <td>{{I18n.l("time.formats.time_with_date", auctionsCatalog.startDate)}}</td>
    <td class="auction__live-button">
      <a
        v-if="inProgress()"
        :href="Routes.employees_auctions_catalog_live_path({ id: auctionsCatalog.slug })"
        class="link--green"
        target="_blank">LIVE</a>
    </td>
    <td>{{I18n.t("orders", { count: auctionsCatalog.ordersCount })}}</td>
  </tr>
</template>

<script>
  import { tableRowNumber } from '@/shared/helpers';
  import { IN_PROGRESS_STATE } from '@/shared/consts';
  import { DEFAULT_PER_PAGE,
    LIVE_AUCTION_TYPE, HAMMER_AUCTION_TYPE } from './../../consts';

  /* global Routes */
  export default {
    data() {
      return {
        perPage: this.$route.params.perPage || DEFAULT_PER_PAGE,
      };
    },
    created() {
      this.Routes = Routes;
      this.tableRowNumber = tableRowNumber;
    },
    name: 'AuctionsCatalogsRow',
    props: {
      auctionsCatalog: Object,
      auctionHouse: Object,
      address: Object,
      index: Number,
    },
    computed: {
      currentPage() {
        return this.$route.query.page || 1;
      },
      auctionType() {
        return window.location.pathname.split('/')[2];
      },
      auctionTypeToPath() {
        return this.auctionType === HAMMER_AUCTION_TYPE ? 'hammer_' : '';
      },
    },
    methods: {
      inProgress() {
        return this.liveAuctionType() && this.auctionsCatalog.state === IN_PROGRESS_STATE;
      },
      liveAuctionType() {
        return this.auctionType === LIVE_AUCTION_TYPE;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/auctions_catalogs/index/components/auctions_catalogs/row.vue?397346ae